import { render, staticRenderFns } from "./TransactionDetailsTable.vue?vue&type=template&id=12388fd5"
import script from "./TransactionDetailsTable.vue?vue&type=script&lang=js"
export * from "./TransactionDetailsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports